@defer (when formReady()) {
<form [formGroup]="form" id="dynamic-form" [class]="layout() === 'kv' ? 'form-kv' : 'container-with-gap'"
  [class.container-with-gap--compact]="compact()" data-testid="dynamic-form" [attr.data-form-value]="formValueJson()">
  @for(f of viewFields(); track f.key) {
  @if (f.isNewSection) {
  <div [class]="layout() === 'kv' ? 'form-kv__section' : 'form-section-title'">{{ f.section }}</div>
  }

  @if (layout() === 'kv') {
  <div class="form-kv__row">
    <span class="form-kv__label" [class.form-kv__label--required]="f.required">{{ f.labelKey }}:</span>
    <div class="form-kv__value">
      <app-dynamic-field [field]="f" [form]="form" [formValue]="formValueSignal()" [refField]="refOf(f)"
        [readonly]="readonly()" [appearance]="'outline'" [cssClass]="f.cssClass || ''" [showLabel]="false"
        [showErrors]="true" (refLabelSelected)="onRefLabelSelected(f, $event)" />
    </div>
  </div>
  } @else {
  <app-dynamic-field [field]="f" [form]="form" [formValue]="formValueSignal()" [refField]="refOf(f)"
    [readonly]="readonly()" [appearance]="'outline'" [showLabel]="true" [showErrors]="true" [ngClass]="spanClass(f)"
    (refLabelSelected)="onRefLabelSelected(f, $event)" />
  }
  }
  <!-- Spacer to prevent content from being hidden behind sticky footers -->
</form>
@if (scrollSpacer()) {
<div style="height: 5rem; width: 100%; flex-shrink: 0;"></div>
}
} @loading {
<div class="flex justify-center items-center h-32">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
}
